import React from "react";
import ContentName from "./ContentName";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { tr } from "../../../i18n";
function Pdf({ data, addSchedule, deleteSingleContent, readOnly = false }) {
  return (
    <>
      <div className="content-item content-item--pdf" key={data.key}>
        <div className="content-image">
          {!readOnly && (
            <div className="content-del-icon">
              <DeleteOutlineIcon
                onClick={() => deleteSingleContent(data.id)}
                style={{ color: "var(--primary-color)" }}
              />
            </div>
          )}
          <div className="content-placeholder content-placeholder--pdf">
            <PictureAsPdfOutlinedIcon sx={{ height: "64px", width: "64px", color: "#e53e3e" }} />
          </div>
        </div>
        <div className="content-bottom">
          <ContentName data={data} readOnly={readOnly} maxLength={24} className="content-title" />
          <p className="content-type-pill">
            <span className="content-type-icon">
              <PictureAsPdfOutlinedIcon sx={{ fontSize: "14px", color: "var(--primary-color)" }} />
            </span>
            <span>{tr("PDF")}</span>
          </p>
        </div>
      </div>
    </>
  );
}

export default Pdf;
